"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
class Batch {
    constructor() {
        this._writeBatch = index_1.firestore.batch();
    }
    save(documentOrDocuments, reference) {
        if (documentOrDocuments instanceof Array && reference instanceof Object) {
            for (const document of documentOrDocuments) {
                const data = document.data();
                if (data) {
                    const documentReference = reference.doc(document.id);
                    data["createdAt"] = index_1.FieldValue.serverTimestamp();
                    data["updatedAt"] = index_1.FieldValue.serverTimestamp();
                    this._writeBatch.set(documentReference, data);
                }
            }
        }
        else if (documentOrDocuments instanceof Object) {
            if (reference instanceof index_1.CollectionReference) {
                fail("[Ballcap: Batch] invalid reference. If you want to save the document, please set DocumentReference.");
            }
            const document = documentOrDocuments;
            const data = document.data();
            if (data) {
                const documentReference = (reference || document.documentReference);
                data["createdAt"] = index_1.FieldValue.serverTimestamp();
                data["updatedAt"] = index_1.FieldValue.serverTimestamp();
                this._writeBatch.set(documentReference, data);
            }
        }
    }
    update(documentOrDocuments, reference) {
        if (documentOrDocuments instanceof Array && reference instanceof Object) {
            for (const document of documentOrDocuments) {
                const data = document.data();
                if (data) {
                    const documentReference = reference.doc(document.id);
                    data["updatedAt"] = index_1.FieldValue.serverTimestamp();
                    this._writeBatch.update(documentReference, data);
                }
            }
        }
        else if (documentOrDocuments instanceof Object) {
            if (reference instanceof index_1.CollectionReference) {
                fail("[Ballcap: Batch] invalid reference. If you want to update the document, please set DocumentReference.");
            }
            const document = documentOrDocuments;
            const data = document.data();
            if (data) {
                const documentReference = (reference || document.documentReference);
                data["updatedAt"] = index_1.FieldValue.serverTimestamp();
                this._writeBatch.update(documentReference, data);
            }
        }
    }
    delete(documentOrDocuments, reference) {
        if (documentOrDocuments instanceof Array && reference instanceof index_1.CollectionReference) {
            for (const document of documentOrDocuments) {
                const documentReference = reference.doc(document.id);
                this._writeBatch.delete(documentReference);
            }
        }
        else if (documentOrDocuments instanceof Object) {
            if (reference instanceof index_1.CollectionReference) {
                fail("[Ballcap: Batch] invalid reference. If you want to delete the document, please set DocumentReference.");
            }
            const document = documentOrDocuments;
            const documentReference = (reference || document.documentReference);
            this._writeBatch.delete(documentReference);
        }
    }
    commit() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._writeBatch.commit();
        });
    }
}
exports.Batch = Batch;
//# sourceMappingURL=Batch.js.map